<div class="main-wrapper-section">
    <div class="common-header">
        <h3>Insurance</h3>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <div class="edit-form-panel">
                <form [formGroup]="insuranceDeductibleForm">
                    <div class="field-form-panel">
                        <h4>{{insuranceDeductibleID > 0 || contactId > 0 ? memInsuranceDeductible?.contactName : 'Add'}}</h4>
                        <hr />
                        <div class="flex-form contracts-flex-form">
                            <div class="form-group">
                                <label>Protection Plan</label>
                                <select class="form-control" formControlName="protectionPlanID">
                                    <option [value]="0">-Select One-</option>
                                    <option *ngFor="let item of ref_MemProtectionPlan_List" [value]="item.statusID">{{item?.status}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Protection Start Date</label>
                                <mat-form-field>
                                    <input matInput #ref [matDatepicker]="protectionStartDate" class="form-control" formControlName="protectionStartDate" id="protectionStartDate">
                                    <mat-datepicker-toggle matSuffix [for]="protectionStartDate"></mat-datepicker-toggle>
                                    <mat-datepicker #protectionStartDate></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group">
                                <label>Protection Deductible Amount</label>
                                <input class="form-control" type="text" formControlName="protectionDeductibleAmount" />
                            </div>
                            <div class="form-group">
                                <label>Lost Equipment Credit Total</label>
                                <input class="form-control" type="text" formControlName="lostEquipmentCreditTotal" />
                            </div>
                            <div class="form-group">
                                <label>Protection End Date</label>
                                <mat-form-field>
                                    <input matInput #ref [matDatepicker]="protectionEndDate" class="form-control" formControlName="protectionEndDate" id="protectionEndDate">
                                    <mat-datepicker-toggle matSuffix [for]="protectionEndDate"></mat-datepicker-toggle>
                                    <mat-datepicker #protectionEndDate></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group">
                                <label>Protection Plan Status</label>
                                <select class="form-control" formControlName="protectionStatusID">
                                    <option [value]="0">-Select One-</option>
                                    <option *ngFor="let item of ref_MemProtectionStatus_List" [value]="item.statusID">{{item?.status}}</option>
                                </select>
                            </div>
                            <div class="form-group" *ngIf="insuranceDeductibleID  == 0 && contactId == 0">
                                <label>Contact</label>
                                <select class="form-control" formControlName="contactId" (change)="onChangeMemContact()">
                                    <option [value]="0">-Select One-</option>
                                    <option *ngFor="let item of memContact_dd" [value]="item.id">{{item?.text}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <button type="button" class="primary-btn" *ngIf="insuranceDeductibleID == 0 && contactId == 0" (click)="memInsuranceDeductible_Create()">Save</button>
                    <button type="button" class="primary-btn" *ngIf="insuranceDeductibleID > 0 || contactId > 0" (click)="memInsuranceDeductible_Update()">Update</button>
                    <button type="button" class="black-btn" *ngIf="insuranceDeductibleID > 0 || contactId > 0"  (click)="memInsuranceDeductible_Delete()">Delete</button>
                </form>
            </div>

            <div class="table-panel">
                <div class="">
                    <div class="text-right">
                        <div class="button-group" style="border:none;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

